import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientsList, getClientsCheckList, selectClientsList, resetStore } from "../../redux/modules/clients";
import Layout from "../layout"
import Loader from "../common/loader"
import Table from "../common/table"
import FilterClients from "./filter-clients"
import FilterСhecklist from "./filter-checklist"
import { Link } from "react-router-dom";

const Clients = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(true);
  const [active, setActive] = useState(0);

  const [fields, setValue] = useState({
    date: {
      value:''
    },
    manager: {
      value:''
    },
    clientName: {
      value:''
    },
    project: {
      value:''
    },
    type: {
      value:''
    },
    search: {
      value:''
    },
    brocker: {
      value:''
    },
  });  
  const [items, setItems] = useState(null);

  const [fields2, setValue2] = useState({
    date: {
      value:''
    },
    phone: {
      value:''
    },
    result: {
      value:''
    },
    search: {
      value:''
    },
    brocker: {
      value:''
    },
  });  
  const [items2, setItems2] = useState(null);

  const auth = useSelector(state => state.auth);
  const clients = useSelector(state => state.clients);
  const checklist = useSelector(state => state.clients.checklist);
  const clientsmodify = useSelector(state => selectClientsList(state));
  const mobile = useSelector(state => state.mobile);

  const scrolled = () => {
    const width = window.innerWidth
    const scrollTop = width < 1000 ? document.querySelector('.page__content').scrollTop : document.querySelector('.tabs-content').scrollTop;
    const height =  width < 1000  ?  (document.querySelector('.visible').offsetTop + document.querySelector('.visible').offsetHeight - 48) : document.querySelector('.visible').offsetHeight;

    if (scrollTop > height ) {
      if(width < 1000) {
        document.querySelector('.table__head').classList.add('fixed');
        document.querySelector('.filter-btn').classList.add('visible');
      } else {
        setVisible(false);
      }
    } else {
      if(width < 1000) {
        document.querySelector('.table__head').classList.remove('fixed');
        document.querySelector('.filter-btn').classList.remove('visible');
      } else {
        setVisible(true);
      }    
    }
  };

  useEffect(() => {    
    document.title = 'Клиенты | Личный кабинет Брокера THE FIVE';
    
    dispatch(getClientsList({
      cmd: 'clients-list',
      _debug_token: auth.token
    }))

    dispatch(getClientsCheckList({
      cmd: 'clients-checklist',
      _debug_token: auth.token
    }))

    
    document.querySelector('.page__content').addEventListener('scroll', scrolled);
    document.querySelector('.tabs-content').addEventListener('scroll', scrolled);    
    
    return () => {      
      if(document.querySelector('.page__content') && document.querySelector('.page__content').length) document.querySelector('.page__content').removeEventListener('scroll', scrolled);
      if(document.querySelector('.tabs-content') && document.querySelector('.tabs-content').length) document.querySelector('.tabs-content').removeEventListener('scroll', scrolled);
      dispatch(resetStore())
    }

  }, []);

  const handleFilterClick = () => {
    setVisible(!visible);
    document.querySelector('.tabs-content').scrollTo(0, 0) 
  };

  const handleClick = e => {
    const index = parseInt(e.target.id, 0);
    if (index !== active) {
      setActive(index);
    }
  };  

  const counts = {
    clientsmodify: clientsmodify ? clientsmodify.length : 0,
    checklist: checklist ? checklist.length : 0,
  };

console.log('checklist', checklist)
console.log(counts.checklist)
  return (
    <Layout>
      {clients.loading && <Loader />}
      <div className="clients-page">
        <div className="tabs">
          <div className="tabs__wrap">
            <div className="tabs__item" onClick={handleClick} data-active={active === 0} id={0}>
              {mobile ? 'Фиксации' : 'Зафиксированные клиенты'}
              {!mobile && counts.clientsmodify > 0 && <div className="tabs__label">{counts.clientsmodify}</div>}
              </div>
            <div className="tabs__item" onClick={handleClick} data-active={active === 1} id={1}>
              {mobile ? 'Проверки' : 'История проверок'}
              {!mobile && counts.checklist > 0 && <div className="tabs__label">{checklist.length}</div>}
            </div>
          </div>
          {/*!mobile && <Link to="/check-client" className="btn">Проверить клиента</Link>*/}
          {!visible && <div className="filter-btn" onClick={handleFilterClick}></div>}
        </div>
      
        <div className="tabs-content">
          {active === 0 && clientsmodify && (<>
              <div className={visible ? "visible" : "visible visible_hide"}>
                <FilterClients fields={fields} setValue={setValue} items={items} setItems={setItems} data={clientsmodify} />
              </div>
              {mobile && <div className="filter-btn" onClick={() => document.querySelector('.page__content').scrollTo(0, 0) }></div>}  
              <Table 
                columns={mobile ? (
                  auth.user.group === 'lead' ? [
                    { label: "Осталось дней", value: "days_left" },
                    { label: "Клиент", value: "clientName" },
                    { label: "Телефон", value: "clientPhone" },
                    { label: "Проект/Тип объекта", value: "project" },
                    { label: "Окончание фиксации", value: "dateEnd" },
                    { label: "Менеджер", value: "manager" },
                    { label: "Брокер", value: "brocker" }
                  ] : [
                    { label: "Осталось дней", value: "days_left" },
                    { label: "Клиент", value: "clientName" },
                    { label: "Телефон", value: "clientPhone" },
                    { label: "Проект/Тип объекта", value: "project" },
                    { label: "Окончание фиксации", value: "dateEnd" },
                    { label: "Менеджер", value: "manager" }
                  ]
                ) : (
                  auth.user.group === 'lead' ? [
                    { label: "Дата фиксации", value: "dateStart" },
                    { label: "Осталось дней", value: "days_left" },
                    { label: "Окончание фиксации", value: "dateEnd" },
                    { label: "Клиент", value: "clientName" },
                    { label: "Телефон", value: "clientPhone" },
                    { label: "Менеджер", value: "manager" },
                    { label: "Проект/Тип объекта", value: "project" },
                    { label: "Брокер", value: "brocker" }
                  ] : [
                    { label: "Дата фиксации", value: "dateStart" },
                    { label: "Осталось дней", value: "days_left" },
                    { label: "Окончание фиксации", value: "dateEnd" },
                    { label: "Клиент", value: "clientName" },
                    { label: "Телефон", value: "clientPhone" },
                    { label: "Менеджер", value: "manager" },
                    { label: "Проект/Тип объекта", value: "project" },
                  ]
                )}
                sortmobile={[
                  { label: "Осталось дней", value: "days_left" },
                  { label: "Клиент", value: "clientName" },
                ]}
                data={items ? items : (clientsmodify ? clientsmodify : [])} 
              />
            </>
          )}  
          {active === 1 && checklist && (<>
            <div className={visible ? "visible" : "visible visible_hide"}>
              <FilterСhecklist fields={fields2} setValue={setValue2} items={items2} setItems={setItems2} data={checklist} />
            </div>
            {mobile && <div className="filter-btn" onClick={() => document.querySelector('.page__content').scrollTo(0, 0) }></div>}  
            <Table 
              columns={mobile ? (
                auth.user.group == 'lead' ? [
                  { label: "Дата проверки", value: "dateCheck" },
                  { label: "Телефон", value: "phone" },
                  { label: "Результат", value: "result" },
                  { label: "Брокер", value: "brocker" }
                ] : [
                  { label: "Дата проверки", value: "dateCheck" },
                  { label: "Телефон", value: "phone" },
                  { label: "Результат", value: "result" },
                ]
              ) : (
                auth.user.group == 'lead' ? [
                  { label: "Дата проверки", value: "dateCheck" },
                  { label: "Номер телефона", value: "phone" },
                  { label: "Результат", value: "result" },
                  { label: "Брокер", value: "brocker" }
                ] : [
                  { label: "Дата проверки", value: "dateCheck" },
                  { label: "Номер телефона", value: "phone" },
                  { label: "Результат", value: "result" },
                ]
              )}
              sortmobile={[
                { label: "Дата проверки", value: "dateCheck" },
                { label: "Телефон", value: "phone" },
              ]}
              data={items2 ? items2 : (checklist ? checklist : [])} 
            /> 
          </>       
        )}    
        </div>        
      </div>
    </Layout>
  )
}

export default Clients